module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-bridge.c8e4b7cd.png";